import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import type { ComponentProps, FC } from "react";

import { useChatForm } from "./use-chat-form";

export interface ChatFormSubmitButtonProps extends ComponentProps<typeof Button> {}

export const ChatFormSubmitButton: FC<ChatFormSubmitButtonProps> = ({ onKeyDown, ...props }) => {
  const { canSubmit, submitButtonRef } = useChatForm();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={submitButtonRef}
          type="submit"
          theme="primary"
          size="xs"
          display="icon"
          disabled={!canSubmit}
          {...props}
        >
          <Icon icon="arrow_upward" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Send</TooltipContent>
    </Tooltip>
  );
};
